import {
  GraduationCap, Wallet, Home, Landmark, Heart, Activity, HeartPulse, HandHeart,
  TrendingUp, CalendarClock, Calculator, KeyRound, Flag, ShieldPlus, ScrollText,
  Briefcase, ClipboardCheck, Users, BookOpen, Shield,
} from "lucide-react";

export const ICONS = {
  "graduation-cap": GraduationCap, wallet: Wallet, home: Home, landmark: Landmark,
  heart: Heart, activity: Activity, "heart-pulse": HeartPulse, "hand-heart": HandHeart,
  "trending-up": TrendingUp, "calendar-clock": CalendarClock, calculator: Calculator,
  "key-round": KeyRound, flag: Flag, "shield-plus": ShieldPlus, "scroll-text": ScrollText,
  briefcase: Briefcase, "clipboard-check": ClipboardCheck, users: Users, "book-open": BookOpen,
  shield: Shield,
};

export const iconFor = (name) => ICONS[name] || BookOpen;
